/**
 * API base URL for Naturals Salon backend requests.
 *
 * Priority:
 * 1. REACT_APP_NATURALS_SALON_API_URL
 * 2. window injected vars
 * 3. Production same-origin: /nyafaz-ep-salon-api → nginx → 5132
 * 4. Dev fallback: localhost:5132
 */
const DEFAULT_DEV_API_ORIGIN = 'http://localhost:5132';
const PRODUCTION_CUSTOMER_HOST = 'analyze.nyafaz.com';
const PRODUCTION_API_PATH = '/nyafaz-ep-salon-api';

function productionApiOriginForHost(origin) {
  try {
    const url = new URL(origin);
    if (String(url.hostname || '').toLowerCase() === PRODUCTION_CUSTOMER_HOST) {
      return `${url.origin}${PRODUCTION_API_PATH}`;
    }
  } catch {
    // ignore
  }
  return null;
}

export function getApiBaseUrl() {
  const fromNaturalsEnv =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_NATURALS_SALON_API_URL;
  if (fromNaturalsEnv && String(fromNaturalsEnv).trim()) {
    return String(fromNaturalsEnv).trim().replace(/\/$/, '');
  }

  const fromEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL;
  const normalizedFromEnv = fromEnv && String(fromEnv).trim() ? String(fromEnv).trim().replace(/\/$/, '') : '';

  if (typeof window !== 'undefined') {
    const fromWindow =
      window.NYAFAZ_NATURALS_SALON_API_URL ||
      window.REACT_APP_NATURALS_SALON_API_URL;
    if (fromWindow && String(fromWindow).trim()) return String(fromWindow).trim().replace(/\/$/, '');

    const origin = window.location && window.location.origin;
    if (origin && (origin === 'http://localhost:3000' || origin === 'https://localhost:3000')) {
      if (normalizedFromEnv === 'http://localhost:5000' || normalizedFromEnv === 'https://localhost:5000') {
        return DEFAULT_DEV_API_ORIGIN;
      }
      if (normalizedFromEnv) return normalizedFromEnv;
      return DEFAULT_DEV_API_ORIGIN;
    }

    const mapped = origin ? productionApiOriginForHost(origin) : null;
    if (mapped) return mapped;

    if (normalizedFromEnv) return normalizedFromEnv;
    if (origin) return origin;
  }

  if (normalizedFromEnv) return normalizedFromEnv;
  return '';
}

export const SALON_API_PREFIX = '/api/salon';
